import { useLang } from '@/i18n';
import { ReactNode } from 'react';

export interface StoryItem {
    title: string | ReactNode;
    desc: string | ReactNode;
    img?: string;
    imgArr?: string[][];
    imgs?: string[][];
    isVideo?: boolean;
    video?: string[];
}

export interface StoryGroup {
    id: string;
    title: string;
    desc: string;
    stories: StoryItem[];
    moreList: StoryItem[];
}

export function useStoriesConfig() {
    const { t } = useLang('corporatesocialresponsibility');

    // Section C - Disaster Relief (US version)
    const secCStories: StoryItem[] = [
        {
            title: t('secC_card22_text'),
            desc: t('secC_card22_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1767858409928-mhh6sw-compressed-RESCUES01.jpg',
            imgArr: [['https://websiteoss.ecoflow.com/upload/image/1753857763866/1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1753857763866/1.jpg']],
        },
        {
            title: t('secC_card24_text'),
            desc: t('secC_card24_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1767858425681-c65u7f-compressed-RESCUES02.jpg',
            imgArr: [
                [
                    'https://websiteoss.ecoflow.com/upload/image/1754530794146/Tamborine.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1754530794146/Tamborine.jpg',
                ],
            ],
        },
        {
            title: t('secC_card23_text'),
            desc: t('secC_card23_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1767858441538-53aohd-compressed-RESCUES03.jpg',
            imgArr: [['https://websiteoss.ecoflow.com/upload/image/1753857763939/2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1753857763939/2.jpg']],
        },
    ];

    const secCMoreList: StoryItem[] = [
        {
            title: t('secC_card14_text'),
            desc: t('secC_card14_desc'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1734489073674/F1.jpg',
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734489073674/F1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734489073674/F1.jpg']],
        },
        {
            title: t('secC_card2_text'),
            desc: t('secC_card2_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_2_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_2_1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_2_2.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_2_2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_2_3.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_2_3.jpg')],
            ],
        },
        {
            title: t('secC_card3_text'),
            desc: t('secC_card3_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_3_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_3_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_3_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_3_2.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_3_3.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_3_3.png')],
            ],
        },
        {
            title: t('secC_card4_text'),
            desc: t('secC_card4_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_4_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_4_1.jpg')],
            ],
        },
        {
            title: t('secC_card5_text'),
            desc: t('secC_card5_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_5_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_5_1.png')],
            ],
        },
        {
            title: t('secC_card6_text'),
            desc: t('secC_card6_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_6_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_6_1.png')],
            ],
        },
        {
            title: t('secC_card7_text'),
            desc: t('secC_card7_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_7_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_7_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_7_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_7_2.png')],
            ],
        },
        {
            isVideo: true,
            title: t('secC_card8_text'),
            desc: t('secC_card8_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_8_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_8_1.png')],
            ],
            video: ['/video/corporate-social-responsibility/pc/6_1.mp4'],
        },
        {
            title: t('secC_card9_text'),
            desc: t.rich('secC_card9_desc', {
                link: (text: string) => (
                    <a className="desc-link" href="https://www.ecoflow.com/jp/support-for-disaster-prevention" target="_blank" rel="noreferrer">
                        {text}
                    </a>
                ),
            }),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_9_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_9_1.png')],
            ],
        },
        {
            title: t('secC_card10_text'),
            desc: t('secC_card10_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_10_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_10_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_10_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/3_10_2.png')],
            ],
        },
        {
            title: t('secC_card13_text'),
            desc: t('secC_card13_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_11_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_11_1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_11_2.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_11_2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_11_3.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_11_3.jpg')],
            ],
        },
        {
            title: t('secC_card1_text'),
            desc: t('secC_card1_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/3_1_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_1_1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/pc/3_1_2.jpg'), require('@publicLocal/corporate-social-responsibility/pc/3_1_2.jpg')],
            ],
        },
        {
            title: t('secC_card16_text'),
            desc: t('secC_card16_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734489723128/F5.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734489723128/F5.jpg']],
        },
        {
            title: t('secC_card17_text'),
            desc: t.rich('secC_card17_desc', {
                link: (text: string) => (
                    <a className="desc-link" href="https://ventadecolchones.com/" target="_blank" rel="noreferrer">
                        {text}
                    </a>
                ),
            }),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734490844937/F6.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734490844937/F6.jpg']],
        },
        {
            title: t('secC_card18_text'),
            desc: t('secC_card18_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734490908713/F7.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734490908713/F7.jpg']],
        },
        {
            title: t('secC_card11_text'),
            desc: t('secC_card11_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/common/D1.jpg'), require('@publicLocal/corporate-social-responsibility/common/D1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/D2.jpg'), require('@publicLocal/corporate-social-responsibility/common/D2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/D3.jpg'), require('@publicLocal/corporate-social-responsibility/common/D3.jpg')],
            ],
        },
        {
            title: t('secC_card12_text'),
            desc: t('secC_card12_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/common/E1.jpg'), require('@publicLocal/corporate-social-responsibility/common/E1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/E2.jpg'), require('@publicLocal/corporate-social-responsibility/common/E2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/E3.jpg'), require('@publicLocal/corporate-social-responsibility/common/E3.jpg')],
            ],
        },
        {
            title: t('secC_card21_text'),
            desc: t('secC_card21_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734491447759/F12.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491447759/F12.jpg']],
        },
        {
            title: t('secC_card19_text'),
            desc: t('secC_card19_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734491198624/F10.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491198624/F10.jpg']],
        },
        {
            title: t('secC_card20_text'),
            desc: t('secC_card20_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734491247005/F11.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491247005/F11.jpg']],
        },
        {
            title: t('secC_card15_text'),
            desc: t('secC_card15_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734489623044/F4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734489623044/F4.jpg']],
        },
    ];

    // Section D - Environmental Protection
    const secDStories: StoryItem[] = [
        {
            title: t('secD_card6_text'),
            desc: t('secD_card6_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1767858640683-tdine7-compressed-ENVIRONMENTS01.jpg',
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/common/C1.jpg'), require('@publicLocal/corporate-social-responsibility/common/C1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/C2.jpg'), require('@publicLocal/corporate-social-responsibility/common/C2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/C3.jpg'), require('@publicLocal/corporate-social-responsibility/common/C3.jpg')],
            ],
        },

        {
            title: t('secD_card3_text'),
            desc: t('secD_card3_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1767858655094-wmz6hc-compressed-ENVIRONMENTS02.jpg',
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/pc/4_3_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_3_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/4_3_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_3_2.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/4_3_3.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_3_3.png')],
            ],
        },
        {
            title: t('secD_card1_text'),
            desc: t('secD_card1_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1767858666879-le7xpt-compressed-ENVIRONMENTS03.jpg',
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/pc/4_1_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_1_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/4_1_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_1_2.png')],
            ],
        },
    ];

    const secDMoreList: StoryItem[] = [
        {
            title: t('secD_card2_text'),
            desc: t('secD_card2_desc'),
            img: require('@publicLocal/corporate-social-responsibility/pc/4_2_1.jpg'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/4_2_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/4_2_1.jpg')],
            ],
        },
        {
            title: t('secD_card4_text'),
            desc: t('secD_card4_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/4_4_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_4_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/4_4_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_4_2.png')],
            ],
        },
        {
            title: t('secD_card5_text'),
            desc: t('secD_card5_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/4_5_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_5_1.png')],
            ],
        },
    ];

    // Section E - Community Support (US version)
    const secEStories: StoryItem[] = [
        {
            title: t('secE_card16_text'),
            desc: t('secE_card16_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1767858564308-pkhurk-compressed-LIVING01.jpg',
            imgArr: [
                [
                    'https://websiteoss.ecoflow.com/upload/image/1753858618195/E16_1.jpeg',
                    'https://websiteoss.ecoflow.com/upload/image/1753858618195/E16_1.jpeg',
                ],
                [
                    'https://websiteoss.ecoflow.com/upload/image/1753858618162/E16_2.jpeg',
                    'https://websiteoss.ecoflow.com/upload/image/1753858618162/E16_2.jpeg',
                ],
            ],
        },

        {
            title: t('secE_card1_text'),
            desc: t('secE_card1_desc'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1769066692148/20260122-152442.webp',
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_1_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_1_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/5_1_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_1_2.png')],
            ],
        },
        {
            title: t('secE_card15_text'),
            desc: t('secE_card15_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1767858619815-6bcgdq-compressed-LIVING03.jpg',
            imgArr: [
                ['https://websiteoss.ecoflow.com/upload/image/1753858056996/E15.jpg', 'https://websiteoss.ecoflow.com/upload/image/1753858056996/E15.jpg'],
            ],
        },
    ];

    const secEMoreList: StoryItem[] = [
        {
            title: t('secE_card14_text'),
            desc: t('secE_card14_desc'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1734491671868/F14.jpg',
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734491671868/F14.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491671868/F14.jpg']],
        },

        {
            title: t('secE_card12_text'),
            desc: t('secE_card12_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734491541959/F13.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491541959/F13.jpg']],
        },
        {
            title: t('secE_card4_text'),
            desc: t('secE_card4_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_4_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/5_4_1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/pc/5_4_2.jpg'), require('@publicLocal/corporate-social-responsibility/pc/5_4_2.jpg')],
            ],
        },
        {
            title: t('secE_card5_text'),
            desc: t('secE_card5_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_5_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_5_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/5_5_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_5_2.png')],
            ],
        },
        {
            title: t('secE_card6_text'),
            desc: t('secE_card6_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_6_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_6_1.png')],
            ],
        },
        {
            title: t('secE_card7_text'),
            desc: t('secE_card7_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_7_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_7_1.png')],
            ],
        },
        {
            title: t('secE_card8_text'),
            desc: t('secE_card8_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_8_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_8_1.png')],
            ],
        },
        {
            title: t('secE_card9_text'),
            desc: t.rich('secE_card9_desc', {
                link: (text: string) => (
                    <a className="desc-link" href="https://za.ecoflow.com/products/delta-max-portable-power-station" target="_blank" rel="noreferrer">
                        {text}
                    </a>
                ),
            }),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_9_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_9_1.png')],
            ],
        },
        {
            title: t('secE_card13_text'),
            desc: t('secE_card13_desc'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734491622748/F15.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491622748/F15.jpg']],
        },
        {
            title: t('secE_card11_text'),
            desc: t('secE_card11_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/common/B1.jpg'), require('@publicLocal/corporate-social-responsibility/common/B1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/B2.jpg'), require('@publicLocal/corporate-social-responsibility/common/B2.jpg')],
            ],
        },
        {
            title: t('secE_card10_text'),
            desc: t('secE_card10_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/common/A1.jpg'), require('@publicLocal/corporate-social-responsibility/common/A1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/A2.jpg'), require('@publicLocal/corporate-social-responsibility/common/A2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/A3.jpg'), require('@publicLocal/corporate-social-responsibility/common/A3.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/A4.jpg'), require('@publicLocal/corporate-social-responsibility/common/A4.jpg')],
            ],
        },
        {
            title: t('secE_card2_text'),
            desc: t('secE_card2_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_2_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/5_2_1.jpg')],
            ],
        },
        {
            title: t('secE_card17_text'),
            desc: t('secE_card17_desc'),
            imgs: [
                ['https://websiteoss.ecoflow.com/upload/image/1754530419201/al2.jpeg', 'https://websiteoss.ecoflow.com/upload/image/1754530419201/al2.jpeg'],
            ],
        },
    ];

    const groupList: StoryGroup[] = [
        {
            id: 'disaster-relief',
            title: t('secC_title'),
            desc: t('secC_desc'),
            stories: secCStories,
            moreList: secCMoreList,
        },
        {
            id: 'environmental',
            title: t('secD_title'),
            desc: t('secD_desc'),
            stories: secDStories,
            moreList: secDMoreList,
        },
        {
            id: 'community',
            title: t('secE_title'),
            desc: t('secE_desc'),
            stories: secEStories,
            moreList: secEMoreList,
        },
    ];

    return { groupList, t };
}
